var React = require('react');

function Play12x12 (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Inverted=off, Size=12x12"},React.createElement("path",{"id":"Polygon 2","d":"M10.496 6.868L12.016 6l-1.52-.868-7-4L2 .277v11.446l1.496-.855 7-4z","stroke":"currentColor","strokeWidth":"2","strokeLinejoin":"round"})));
}

Play12x12.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = Play12x12;

Play12x12.default = Play12x12;
